import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/fitglobal.webp';
import screenshot_target from '../../../images/letterfunnel/recepbakirci.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Recep Bakirci"
      firstname="Recep"
      companyname="FIT Global"
      competition="HSO en Annata"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/recepbakirci.js